import React from "react";
import { Card, Typography, Input, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";

const { Title } = Typography;
const { TextArea } = Input;

export default function ContentCard({ title, explanation, route }) {
  const navigate = useNavigate();
  return (
    <Card
      style={{
        width: "95%",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 20,
      }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          <span style={{ marginTop: 5 }}>{explanation}</span>
        </Col>

        <Col>
          <Button
            type="primary"
            style={{ backgroundColor: "#8e44ad", borderColor: "#8e44ad" }}
            onClick={() => {
              navigate(route);
            }}>
            Gözat
          </Button>
        </Col>
      </Row>
    </Card>
  );
}
